import { render, staticRenderFns } from "./PropViewSwitch.vue?vue&type=template&id=4ec773a9&scoped=true"
import script from "./PropViewSwitch.vue?vue&type=script&lang=js"
export * from "./PropViewSwitch.vue?vue&type=script&lang=js"
import style0 from "./PropViewSwitch.vue?vue&type=style&index=0&id=4ec773a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec773a9",
  null
  
)

export default component.exports